import * as React from 'react';

import loadable from '@loadable/component';

interface IconPropsIO {
  icon: string;
  className?: string;
  onClick?: (event) => void;
}

const Icon = loadable(() => import('./Icon'));

class IconLazy extends React.Component<IconPropsIO> {
  public render() {
    const { icon, className, onClick } = this.props;

    return <Icon icon={icon} className={className} onClick={onClick} />;
  }
}

export default IconLazy;
